import {Component} from '@angular/core';
import {ComponentType} from '@angular/cdk/overlay';
import {DatepickerComponent} from '../../../datepicker/datepicker.component';
import {ParamBaseComponent} from '../../../../bases/param-base-component';
import {Observable} from 'rxjs';
import {AdRPeriod} from '../../../../interfaces/ad-reports';
import {selectPeriods} from '../../../../store/periods/periods.selectors';

@Component({
  selector: 'app-param-datepicker',
  templateUrl: './report-param-datepicker.component.html',
  styleUrls: ['./report-param-datepicker.component.scss']
})
export class ReportParamDatepickerComponent extends ParamBaseComponent {
  public readonly component: ComponentType<any> = DatepickerComponent;
  public readonly options$: Observable<Array<AdRPeriod>> = this._store.select(selectPeriods);
}
